import PubSub from 'pubsub-js';
import type UpdateTicketCheckStateData from '../types/UpdateTicketCheckStateData';

export const UPDATE_TICKET_CHECK_STATE_ID = Symbol('7T:Tickets.UpdateTicketCheckState');

export const updateTicketCheckStateEventPubSub:
PubSubJS.Base<UpdateTicketCheckStateData, typeof UPDATE_TICKET_CHECK_STATE_ID> = PubSub;
